import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames/bind";
import styles from "./Index.module.scss";
import { createAxios } from "../../../createInstance";
import { loginSuccess } from "../../../redux/authSlice";
import { getCustomer, loginUserFb, getUsersOfCustomer, createUserForCustomer } from "../../../redux/apiRequest";
import ToastMessage, { showToast } from "../../../Components/ToastMessage";
import { Environment } from "../../../environment/environment";

const cx = classNames.bind(styles);

const Customer = () => {
  const { slug } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.login.currentUser);
  const axiosJWT = createAxios(user, dispatch, loginSuccess, navigate);
  const customer = useSelector((state) => state.customer.detail?.currentCustomer);
  const isFetching = useSelector((state) => state.customer.detail?.isFetching);
  const accounts = useSelector((state) => state.user.users.allUsers);

  const [showAccountModal, setShowAccountModal] = useState(false);
  const [accUsername, setAccUsername] = useState("");
  const [accPassword, setAccPassword] = useState("");
  const [accFullname, setAccFullname] = useState("");
  const [accEmail, setAccEmail] = useState("");

  const handleClickLoginFB = () => {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          handleResponseFacebook(response.authResponse);
        } else {
          alert("Người dùng đã huỷ đăng nhập hoặc từ chối.");
        }
      },
      {
        scope:
          "pages_show_list,pages_read_engagement,pages_read_user_content,read_insights",
      }
    );
  };
  const handleResponseFacebook = async (authData) => {
    try {
      const result = await loginUserFb(authData.accessToken, slug);
      if (result) {
        showToast({
          type: "success",
          title: "Thành công!",
          message: "Bạn đã liên kết tài khoản facebook thành công",
          duration: 3000
        })
      } else {
        showToast({
          type: "warning",
          title: "Cảnh báo!",
          message: "Bạn không có quyền truy cập tài khoản này!",
          duration: 3000
        })
      }
    } catch (error) {
      // const data = error?.response?.data;
      showToast({
        type: "error",
        title: "Cảnh báo!",
        message: "Liên kết tài khoản thất bại, vui lòng thử lại!",
        duration: 3000
      })
    }
  };
  const handleClickLoginTiktok = () => {
    window.location.href = `${Environment.BASE_API}/auth/tiktok/${slug}`;
  };


  const handleAddAccount = () => {
    setAccUsername("");
    setAccPassword("");
    setAccFullname("");
    setAccEmail("");
    setShowAccountModal(true);
  };

  const handleSubmitAccount = (e) => {
    e.preventDefault();
    if (!user) return;
    const data = {
      username: accUsername,
      password: accPassword,
      fullname: accFullname,
      email: accEmail,
    };
    const successCallback = () => {
      showToast({
        type: "success",
        title: "Thành công!",
        message: "Tạo tài khoản thành công.",
        duration: 3000,
      });
      setShowAccountModal(false);
    };
    const failedCallback = () => {
      showToast({
        type: "error",
        title: "Thất bại!",
        message: "Tạo tài khoản thất bại.",
        duration: 3000,
      });
    };
    createUserForCustomer(slug, data, user.accessToken, dispatch, axiosJWT, successCallback, failedCallback);
  };

  useEffect(() => {
    if (user && slug) {
      getCustomer(slug, user.accessToken, dispatch, axiosJWT);
      if (user.admin) {
        getUsersOfCustomer(slug, user.accessToken, dispatch, axiosJWT);
      }
    }
  }, [slug]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('tiktok') === 'success') {
      showToast({
        type: "success",
        title: "Thành công!",
        message: "Bạn đã liên kết tài khoản TikTok thành công",
        duration: 3000
      });
      const url = new URL(window.location.href);
      url.searchParams.delete('tiktok');
      window.history.replaceState({}, '', url.toString());
    }
  }, [location.search]);

  if (isFetching) {
    return <div className={cx("loading")}>Loading...</div>;
  }

  if (!customer) {
    return <div className={cx("error")}>Customer not found</div>;
  }
  return (
    <div className={cx("wrapper")}>
      {customer.businessLogo && (
        <img
          src={customer.businessLogo}
          alt={customer.businessName}
          className={cx("logo")}
        />
      )}
      <h2 className={cx("name")}>{customer.businessName}</h2>
      {customer.businessAddress && (
        <p className={cx("info")}>{customer.businessAddress}</p>
      )}
      {customer.businessEmail && (
        <p className={cx("info")}>{customer.businessEmail}</p>
      )}
      {/* BEGIN FACEBOOK */}
      <div className={cx("accounts")}>
        <div className={cx("account-header")}>
          <h3>Facebook</h3>
          <button onClick={handleClickLoginFB}>Add Account</button>
        </div>
        <table className={cx("account-table")}>
          <thead>
            <tr>
              <th>Tên Fanpage</th>
              <th>ID</th>
            </tr>
          </thead>
          <tbody>
            {customer.facebook && customer.facebook.length > 0 ? (
              customer.facebook.map((fb, i) => (
                <tr key={i}>
                  <td>{fb.pageName}</td>
                  <td>{fb.pageId}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2}>Chưa có Fanpage nào được liên kết</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* END FACEBOOK */}

      {/* BEGIN TIKTOK */}
      <div className={cx("accounts")}>
        <div className={cx("account-header")}>
          <h3>TikTok</h3>
          <button onClick={handleClickLoginTiktok}>Add Account</button>
        </div>
        <table className={cx("account-table")}>
          <thead>
            <tr>
              <th>Tên tài khoản</th>
              <th>Open ID</th>
            </tr>
          </thead>
          <tbody>
            {customer.tiktok.map((tk, i) => (
              <tr key={i}>
                <td>{tk.displayName}</td>
                <td>{tk.openId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* END TIKTOK */}

      {/* BEGIN ACCOUNT */}
      {user.admin && (
        <div className={cx("accounts")}>
          <div className={cx("account-header")}>
            <h3>Accounts</h3>
            <button onClick={handleAddAccount}>Add Account</button>
          </div>
          <table className={cx("account-table")}>
            <thead>
              <tr>
                <th>Username</th>
                <th>Full name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((acc) => (
                <tr key={acc._id}>
                  <td>{acc.username}</td>
                  <td>{acc.fullname}</td>
                  <td>{acc.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* END ACCOUNT */}

      {showAccountModal && (
        <div className={cx("modal-overlay")}>
          <div className={cx("modal")} onClick={(e) => e.stopPropagation()}>
            <h2 className={cx("modal-title")}>Add Account</h2>
            <form className={cx("form")} onSubmit={handleSubmitAccount}>
              <label className={cx("label")}>
                Username
                <input className={cx("input")} value={accUsername} onChange={(e) => setAccUsername(e.target.value)} />
              </label>
              <label className={cx("label")}>
                Password
                <input type="password" className={cx("input")} value={accPassword} onChange={(e) => setAccPassword(e.target.value)} />
              </label>
              <label className={cx("label")}>
                Full name
                <input className={cx("input")} value={accFullname} onChange={(e) => setAccFullname(e.target.value)} />
              </label>
              <label className={cx("label")}>
                Email
                <input className={cx("input")} value={accEmail} onChange={(e) => setAccEmail(e.target.value)} />
              </label>
              <div className={cx("actions")}>
                <button type="button" className={cx("cancel-button")} onClick={() => setShowAccountModal(false)}>Cancel</button>
                <button type="submit" className={cx("submit-button")}>Save</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ToastMessage />
    </div>
  );
};

export default Customer;

